/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddStation200Response
 */
export interface AddStation200Response {
    /**
     * 
     * @type {string}
     * @memberof AddStation200Response
     */
    uuid?: string;
}

/**
 * Check if a given object implements the AddStation200Response interface.
 */
export function instanceOfAddStation200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddStation200ResponseFromJSON(json: any): AddStation200Response {
    return AddStation200ResponseFromJSONTyped(json, false);
}

export function AddStation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddStation200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
    };
}

export function AddStation200ResponseToJSON(value?: AddStation200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
    };
}

